import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP } from './LegalPages';

export function CareersPage() {
  const { t } = useTranslation();

  const roles = [
    {
      title: t('careers.role_eng_title'),
      location: t('careers.role_eng_location'),
      body: t('careers.role_eng_body'),
    },
    {
      title: t('careers.role_se_title'),
      location: t('careers.role_se_location'),
      body: t('careers.role_se_body'),
    },
    {
      title: t('careers.role_design_title'),
      location: t('careers.role_design_location'),
      body: t('careers.role_design_body'),
    },
    {
      title: t('careers.role_cs_title'),
      location: t('careers.role_cs_location'),
      body: t('careers.role_cs_body'),
    },
  ];

  return (
    <LegalShell titleKey="careers.title">
      <LegalLead>{t('careers.lead')}</LegalLead>

      <LegalH2>{t('careers.how_title')}</LegalH2>
      <LegalP>{t('careers.how_body')}</LegalP>

      <LegalH2>{t('careers.roles_title')}</LegalH2>
      <div className="mt-4 space-y-px bg-ink-200 border border-ink-200">
        {roles.map((r) => (
          <div key={r.title} className="bg-white p-5">
            <div className="flex items-baseline justify-between gap-4 flex-wrap">
              <p className="text-sm font-semibold text-ink-900">{r.title}</p>
              <p className="text-xs uppercase tracking-wide text-ink-500">{r.location}</p>
            </div>
            <p className="mt-2 text-[13px] text-ink-600 leading-relaxed">{r.body}</p>
          </div>
        ))}
      </div>

      <LegalH2>{t('careers.apply_title')}</LegalH2>
      <LegalP>
        {t('careers.apply_body')}{' '}
        <code className="text-ink-900 font-mono">{t('careers.apply_email')}</code>
      </LegalP>
    </LegalShell>
  );
}
